import {connect} from '@store/@common';

import {getTreeById} from '@store/kpi';
import KpiGoalActions from '@store/kpi/KpiTargetActions';

import {KpiGoalForm} from './KpiGoalForm';

const mapStateToProps = {
  getKpiById: getTreeById,
};

const mapDispatchToProps = {
  fetchGoalKpiTree: KpiGoalActions.fetchGoalKpiTree,
};

export default connect(KpiGoalForm, mapStateToProps, mapDispatchToProps);
